import { Button, Screen, Text } from "components"
import React, { useEffect, useState } from "react"
import { Image, TouchableOpacity, View, useWindowDimensions } from "react-native"
import { style } from "./styles"
import { useNavigation, useRoute } from "@react-navigation/native"
import { translate } from "i18n"
import Icon from "@expo/vector-icons/MaterialIcons"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"
import flash from "config/flash"
import { colors } from "colors"
import Modal from "react-native-modal"
import QRCode from "react-native-qrcode-svg"
import moment from "moment-timezone"
import { useSessionExpired } from "utils/function"
import { useStores } from "models"
import { filter, size } from "lodash"
import { typography } from "theme"

export const CouponDetailScreen = () => {
  const navigation = useNavigation<any>()
  const route = useRoute()
  const { item, routeFrom }: any = route?.params || {}
  const { height, width } = useWindowDimensions()
  const [isTncOpen, setIsTncOpen] = useState(false)
  const [isRedeemOpen, setIsRedeemOpen] = useState(false)
  const [data] = useState(item)
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const { userStore, couponStore } = useStores()

  const [isUserUseVoucher, setIsUserUsedVoucher] = useState(false)
  const [countdown, setCountdown] = useState(-1)
  const [isSavedCoupon, setIsSavedCoupon] = useState(false)
  const [isVoucherExpired, setIsVoucherExpired] = useState(
    item?.use_at
      ? moment().tz("Asia_Kuala_Lumpur").isAfter(moment(item?.use_at)?.add("m", 15))
      : false,
  )

  const coupons = filter(couponStore?.coupons, (e) => {
    return item?.coupon_id === e?.coupon_id
  })

  useEffect(() => {
    if (size(coupons) > 0 && coupons[0]?.couponStatus === "redeem") {
      setIsSavedCoupon(true)
    }
    if (size(coupons) > 0 && coupons[0]?.couponStatus === "used") {
      setIsUserUsedVoucher(true)
    }
  }, [coupons])

  const { couponStatus } = coupons[0] || []

  // useEffect(() => {
  //   routeFrom === "voucherFrom" && getUserPoint()
  // }, [])

  useEffect(() => {
    if (isUserUseVoucher && item?.use_at) {
      const expirationTime = moment(item?.use_at).add(15, "minutes")
      const countdownSeconds = expirationTime.diff(moment(), "seconds")
      setCountdown(countdownSeconds)
    }
  }, [isUserUseVoucher, item?.use_at])

  useEffect(() => {
    let timer

    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1)
      }, 1000)
    } else if (countdown === 0) {
      onCloseModal()
      setIsVoucherExpired(true)
    }

    return () => clearInterval(timer)
  }, [countdown >= 0])

  const formatCountdown = () => {
    const minutes = Math.floor(countdown / 60)
    const seconds = countdown % 60
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }

  const onCloseModal = () => {
    setIsModalVisible(false)
  }

  const onPressUserUseCoupon = () => {
    setIsUserUsedVoucher(true)
    couponStore?.useCoupon(item?.coupon_id)
  }

  console.log(coupons[0]?.couponStatus, "---status")
  // const getUserPoint = async () => {
  //   await fetch(`${process.env.API_URL}/api/client/pointbal`, {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `bearer ${userStore?.accessToken}`,
  //     },
  //   })
  //     .then(async (res) => {
  //       if (res?.ok) {
  //         const responseData = await res?.json()
  //         setPoint(responseData?.data?.bal_point_amt)
  //         userStore?.update({
  //           totalPoint: responseData?.data?.bal_point_amt,
  //         })
  //       } else {
  //         const errorMsg = await res?.json()
  //         if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
  //           sessionExpired()
  //         }
  //       }
  //     })
  //     .catch((e) => {
  //       console.error(e)
  //     })
  // }

  // const redeemVoucher = async () => {
  //   await fetch(`${process.env.API_URL}/api/voucher/redeem`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `bearer ${userStore?.accessToken}`,
  //     },
  //     body: JSON.stringify({
  //       voucher_id: data?.voucher_id,
  //       member_id: userStore?.id,
  //     }),
  //   })
  //     .then(async (res) => {
  //       if (res?.ok) {
  //         onCloseModal()
  //         navigation.goBack()
  //         flash("success", translate("voucherDetailScreen.redeemSuccesfully"))
  //       } else {
  //         onCloseModal()

  //         const errorMsg = await res?.json()

  //         console.log(errorMsg?.message)
  //         if (errorMsg?.message === "Token expired" || errorMsg?.message === "Invalid token") {
  //           sessionExpired()
  //         } else if (errorMsg?.message === "Error redeem voucher. No stock is available.") {
  //           flash("error", translate("errors.outOfStock"))
  //         } else if (
  //           errorMsg?.message === "Error redeem voucher. Balance is not enough to redeem."
  //         ) {
  //           flash("error", translate("errors.notEnoughPoint"))
  //         } else {
  //           flash("error", translate("errors.failedToRedeem"))
  //         }
  //       }
  //     })
  //     .catch((e) => {
  //       flash("error", translate("errors.failedToRedeem"))
  //       console.error(e)
  //     })
  // }

  // const userUserVoucher = async () => {
  //   await fetch(`${process.env.API_URL}/api/voucher/${userStore?.id}/${item?.bar_code}`, {
  //     method: "PUT",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `bearer ${userStore?.accessToken}`,
  //     },
  //   })
  //     .then(async (res) => {
  //       if (res?.ok) {
  //         setCountdown(900)
  //         setIsUserUsedVoucher(true)
  //       } else {
  //         const errorMsg = await res?.json()
  //         if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
  //           sessionExpired()
  //         } else {
  //           onCloseModal()
  //           flash("error", translate("errors.failedToUseVoucher"))
  //         }
  //       }
  //     })
  //     .catch((e) => {
  //       onCloseModal()
  //       flash("error", translate("errors.failedToUseVoucher"))
  //       console.error(e)
  //     })
  // }

  const Accordion = ({ type, text }: { type: "redeem" | "tnc"; text: string }) => {
    const openAccordion = type === "redeem" ? isRedeemOpen : isTncOpen
    const setOpenAccordion = type === "redeem" ? setIsRedeemOpen : setIsTncOpen
    return (
      <View style={style.accordionContainer}>
        <TouchableOpacity
          onPress={() => {
            setOpenAccordion(!openAccordion)
          }}
          style={style.accordionTitleContainer}
        >
          <Text>{translate("promotionDetailScreen.tnc")}</Text>
          {openAccordion ? (
            <MaterialCommunityIcons name="chevron-up" size={24} color={colors.palette.primary} />
          ) : (
            <MaterialCommunityIcons name="chevron-down" size={24} color={colors.palette.primary} />
          )}
        </TouchableOpacity>
        {openAccordion && (
          <View>
            <View style={style.accordionContentContainer} />
            <Text>{text}</Text>
          </View>
        )}
      </View>
    )
  }

  return (
    <>
      <Screen preset="scroll" contentContainerStyle={style.scrollContent}>
        <View>
          <View>
            <Image
              source={{
                uri: data?.img_full_url,
              }}
              resizeMode="stretch"
              style={[style.image, { height: width * 0.6, maxHeight: height * 0.4 }]}
            />
            <TouchableOpacity onPress={() => navigation.goBack()} style={style.headerLeftButton}>
              <Icon name="arrow-back" size={28} color="white" />
            </TouchableOpacity>
          </View>
          <View style={style.container}>
            <Text style={style.title}>{data?.coupon_name}</Text>

            <View style={style.calendarContainer}>
              <MaterialCommunityIcons
                name="calendar-month"
                size={28}
                color={colors.palette.primary}
              />
              <Text style={style.dateText}>
                {moment(item?.start_at).format("DD-MMM-YYYY")} -{" "}
                {moment(item?.end_at).format("DD-MMM-YYYY")}
              </Text>
            </View>

            <Text style={style.description}>{item?.description}</Text>

            {/* Accordian dropdown */}

            <Accordion type="tnc" text={item?.tnc} />
          </View>
          {/* Sticky bottom */}
        </View>
      </Screen>
      <View
        style={[
          style.stickyBottomContainer,
          routeFrom === "voucherHistory"
            ? !isVoucherExpired
              ? {}
              : {
                  backgroundColor: colors.background,
                }
            : {},
        ]}
      >
        {routeFrom === "voucherHistory" ? (
          !isVoucherExpired ? (
            <Button
              onPress={() => {
                setIsModalVisible(true)
              }}
              title={translate("voucherDetailScreen.useVoucher")}
              style={style.buttonContainer}
              titleStyle={style.buttonText}
            />
          ) : (
            <Text style={style.usedExpiredText}>
              {item?.use_at
                ? translate("voucherDetailScreen.usedOn")
                : translate("voucherDetailScreen.expiredOn")}{" "}
              {moment(item?.use_at ? item?.use_at : item?.end_at).format("DD/MM/YYYY • hh:mm")}
            </Text>
          )
        ) : (
          <>
            <Button
              onPress={() => {
                if (!couponStatus) {
                  couponStore?.addCoupon({ ...item, couponStatus: "redeem" })
                  flash("success", "Coupon has been saved")
                  setIsSavedCoupon(true)
                } else {
                  setIsModalVisible(true)
                }
              }}
              title={
                couponStatus === "redeem"
                  ? "Use Coupons"
                  : couponStatus === "used"
                  ? "View Coupons"
                  : "Save Coupons"
              }
              style={style.buttonContainer}
              titleStyle={style.buttonText}
            />
          </>
        )}
      </View>

      <Modal
        isVisible={isModalVisible}
        onBackdropPress={() => {
          if (isUserUseVoucher && routeFrom !== "voucherHistory") {
            navigation.goBack()
            flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
            onCloseModal()
          } else {
            onCloseModal()
          }
        }}
        onBackButtonPress={() => {
          if (isUserUseVoucher && routeFrom !== "voucherHistory") {
            navigation.goBack()
            flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
            onCloseModal()
          } else {
            onCloseModal()
          }
        }}
      >
        <View style={style.modalContainer}>
          {!isUserUseVoucher ? (
            <>
              <Text>{"Are you sure you want to use coupons?"}</Text>
              <Text style={{ marginTop: 10, fontFamily: typography.primary.normal, fontSize: 12 }}>
                {"Please be ready before using this coupon"}
              </Text>
              <View style={style.redeemModalContainer}>
                <Button
                  onPress={() => onCloseModal()}
                  title={translate("voucherDetailScreen.useLater")}
                  style={style.redeemLaterButton}
                  titleStyle={{
                    color: colors.palette.primary,
                  }}
                />
                <Button
                  onPress={() => {
                    onPressUserUseCoupon()
                  }}
                  title={"Confirm"}
                  style={style.flex}
                />
              </View>
            </>
          ) : (
            <>
              <QRCode size={150} value={item?.bar_code} />
              <View style={style.dividerView}>
                <View style={style.dividerViewStyle} />
              </View>
              <Text style={style.qrText}>{translate("voucherDetailScreen.enjoyDeals")}</Text>
              <Button
                onPress={() => {
                  if (isUserUseVoucher && couponStatus !== "used") {
                    navigation.goBack()
                    flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
                    onCloseModal()
                  } else {
                    onCloseModal()
                  }
                }}
                style={style.mt30}
                title={translate("common.confirm")}
              />
            </>
          )}
        </View>
      </Modal>
    </>
  )
}
